export default function onClose(file) {
    let files = [...this.value];
    var index = files.indexOf(file);
    if (index !== -1) files.splice(index, 1);
    this.$emit("input", files);
    this.removeServerFile(file);
}
